import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Key } from 'react';
import getConfig from '../../../helpers/config';
import { Personi } from '../../../interfaces/Auth';
import {
  PaginationProps,
  PaginationReturn,
} from '../../../interfaces/pagination';
import { getPrepareHeaders } from '../get-prepare-headers';
import { InstitutionProps } from '../institucioni/institucioni-api';
const { test } = getConfig();

export interface ActiveResponseConfigurationData {
  id?: string;
  currentPage: number;
  totalPages: number;
  totalElements: number;
}
export interface ParticipantData {
  key: Key;
  id: number;
  emri: string;
  mbiemri: string;
  numriPersonal: string;
  funksioni: string;
  emriInstitucionit: string;
  institucioniLabel: string;
  institucioniId: number;
  personiId?: number;
  fushatVeprimtarise: string[];
}
interface ParticipantsResponseProps extends ActiveResponseConfigurationData {
  data: Array<ParticipantsProps>;
}

export interface ParticipantDataInfoProps {
  perdorues: {
    id?: number;
    personi: Personi;
    email: string;
    fjalekalimi: string;
    fjalekalimiPerseritur: string;
    aktiv?: boolean;
    firstLogIn?: boolean;
  };
  pjesemarres: Omit<PjesemarresProps, 'id'>;
}
export interface PjesemarresProps {
  id: number;
  institucioniId: number;
  funksioni: string;
  fushatVeprimtarise: string[];
}
export interface ParticipantsProps {
  id: number;
  personi: Personi;
  institucioni: InstitutionProps;
  funksioni: string;
  fushatVeprimtarise: string[];
}

export interface ParticipantsSubmitProps extends Personi {
  perdoruesId?: number;
  email: string;
  fjalekalimi: string;
  fjalekalimiPerseritur: string;
  funksioni: string;
  activ: boolean;
  institucioniId: number;
  fushatVeprimtarise: string[];
}

export interface ParticipantsFiltersProps extends PaginationProps {
  emriMbiemri?: string;
  personiEmri?: string;
  funksioni?: string;
  institucioniId?: string;
}

export interface SimplifiedParticipantsProps {
  id: number;
  personi: Personi;
  institucioniEmri: string;
  institucioniQyteti: string;
  niveliPrioritetit: string;
}

export interface EkspertizaProps {
  ekspertiza: string;
}

export interface PersonalDataRequestBody {
  emri?: string;
  mbiemri?: string;
  atesia: string;
  numriPersonal: string;
  ditelindja: string;
  gjinia: 'MASHKULL' | 'FEMER';
  vendbanimi: string;
  shtetesia: string;
  numerTelefoni: string;
  funksioni: string;
  fushatVeprimtarise: string[];
  fushaEkspertizes: string;
  institucioni: { id: number };
}

export const pjesmarresApi = createApi({
  reducerPath: 'pjesmarresApi',
  baseQuery: fetchBaseQuery({
    baseUrl: test.baseUrl + `/`,
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['pjesmarres'],
  endpoints: builder => ({
    createParticipants: builder.mutation<void, ParticipantDataInfoProps>({
      query: body => {
        return {
          url: '/pjesemarres',
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['pjesmarres'],
    }),
    getaAllParticipants: builder.query<
      ParticipantsResponseProps,
      ParticipantsFiltersProps
    >({
      query: args => {
        let url = `/pjesemarres?page=${args.page}&sort=emer:asc`;

        if (args) {
          url += queryParticipantValue(args);
        }

        return { url, method: 'GET' };
      },
      providesTags: ['pjesmarres'],
    }),
    updateParticipant: builder.mutation<void, PjesemarresProps>({
      query: ({ id, ...arg }) => {
        return {
          url: `/pjesemarres/${id}`,
          method: 'PUT',
          body: arg,
        };
      },
      invalidatesTags: ['pjesmarres'],
    }),
    getAllSimplifiedParticipants: builder.query<
      PaginationReturn<SimplifiedParticipantsProps>,
      ParticipantsFiltersProps
    >({
      query: args => {
        let url = `/pjesemarres/simplified?page=${args.page}&sort=emer:asc`;
        if (args) {
          url += queryParticipantValue(args);
        }

        return { url, method: 'GET' };
      },
      providesTags: ['pjesmarres'],
    }),
    updateEkspertiza: builder.mutation<void, EkspertizaProps>({
      query: ({ ...arg }) => {
        return {
          url: `/pjesemarres/ekspertiza`,
          method: 'PUT',
          body: arg,
        };
      },
      invalidatesTags: ['pjesmarres'],
    }),
    updatePersonalData: builder.mutation<void, PersonalDataRequestBody>({
      query: body => ({
        url: `/pjesemarres/personal-data`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['pjesmarres'],
    }),
  }),
});

export const {
  useGetaAllParticipantsQuery,
  useCreateParticipantsMutation,
  useUpdateParticipantMutation,
  useLazyGetAllSimplifiedParticipantsQuery,
  useUpdateEkspertizaMutation,
  useUpdatePersonalDataMutation,
} = pjesmarresApi;

function queryParticipantValue(args: ParticipantsFiltersProps) {
  let url = '';
  if (args.size) {
    url += `&size=${args.size}`;
  }
  if (args.emriMbiemri) {
    url += `&filter=emriMbiemri:ilike:${args.emriMbiemri}`;
  }

  if (args.personiEmri) {
    url += `&filter=personiEmri:ilike:${args.personiEmri}`;
  }

  if (args.funksioni) {
    url += `&filter=funksioni:eq:${args.funksioni}`;
  }
  if (args.institucioniId) {
    url += `&filter=institucioniId:eq:${args.institucioniId}`;
  }
  return url;
}
